<template>
    <div>
        <div class="box-shadow mb-40">
            <div class="row">
                <div class="col-sm-10 col-md-7 col-lg-4">
                    <div class="mb-32 input-box">
                        <label for="name" class="color-text-label" :class="{'error-form': $v.name.$error}">Имя/Название компании</label>
                        <input id="name" type="text"
                               @input="delayTouch($v.name)"
                               v-model.trim="name">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.name.$error && !$v.name.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-10 col-md-7 col-lg-4">
                    <div class="mb-32 input-box">
                        <label for="phone" class="color-text-label" :class="{'error-form': $v.phone.$error}">Телефон</label>
                        <input id="phone" type="text" @input="delayTouch($v.phone)" v-model.trim="phone">
                               <!-- placeholder="+375"
                               @input="delayTouch($v.phone)"
                               v-model.trim="phone"
                               v-mask="'+375#########'"> -->
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.phone.$error && !$v.phone.minLength">Проверьте формат введенного номера.</div>
                            <div class="h6 pt-1 error-form" v-if="$v.phone.$error && !$v.phone.required">Поле обязательно для заполнения</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-10 col-md-7 col-lg-4">
                    <div class="mb-32 input-box">
                        <label for="email" class="color-text-label" :class="{'error-form': $v.email.$error}">Email</label>
                        <input id="email" type="email"
                               @input="delayTouch($v.email)"
                               v-model.trim="email">
                        <div class="error-box">
                            <div class="h6 pt-1 error-form" v-if="$v.email.$error && !$v.email.email">Email введен не верно.</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-10 col-md-7 col-lg-4">
                    <label class="color-text-label">Фото профиля</label>

                    <div class="profile-image__load">
                        <div class="img-container" v-if="profile_image && !picture && !preview_image">
                            <img :src="profile_image" alt="">
                        </div>
                        <div class="img-container" v-if="!profile_image && !picture && !preview_image">
                            <img src="/svg/user.svg" alt="">
                        </div>

                        <div class="img-container" v-if="preview_image">
                            <img :src="preview_image" alt="" v-if="preview_image">
                        </div>

                        <div class="mb-20 form--item profile-image-loader">
                            <b-form-file :placeholder="profile_image ? 'Изменить фото' : 'Загрузить изображение'"
                                         accept="image/jpeg, image/png"
                                         @change="previewThumbnail"
                                         v-model="picture">
                                <template slot="file-name" slot-scope="{ name }">
                                    <span>Изображение добавлено</span>
                                </template>
                            </b-form-file>

                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div>
            <button class="button btn-large" @click="saveChanges()">Сохранить изменения</button>
        </div>

        <div v-if="loading" class="loading-box">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>


<script>
    import { phoneRule, requiredRule, emailRule } from '../../../../services/validation';
    const touchMap = new WeakMap();

    export default {
        data() {
            return {
                name: null,
                phone: null,
                email: null,
                picture: null,

                profile_image: null,
                preview_image: null,

                loading: true
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        mounted() {
            this.init();
        },


        watch: {
            user() {
                this.init();
            }
        },

        methods: {
            init() {
                if(this.user) {
                    this.phone = this.user.userData.phone;
                    this.name = this.user.userData.name;
                    this.email = this.user.userData.email;
                    this.profile_image = '/storage/users/'+this.user.userData.id+'/'+this.user.userData.picture;
                    this.loading = false;
                }
            },

            saveChanges() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/update-user-info';

                    let params = {
                        phone: this.phone,
                        email: this.email,
                        name: this.name,
                        picture: this.picture,
                    };
                    let formData = new FormData();
                    for (let key in params)
                        if (params[key]) formData.append(key, params[key]);

                    const options = {
                        headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                    };

                    axios.post(url, formData, options)
                        .then(response => {
                            if(response.status == 200) {
                                this.$store.dispatch('fetchUser');
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Готово!',
                                    html: `Данные успешно изменены.`,
                                })
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            },

            previewThumbnail: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.preview_image = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            }
        },

        validations: {
            phone: phoneRule,
            name: requiredRule,
            email: emailRule
        }
    }
</script>
